// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3bHjY","title":"Images90_title__2mDpn","images":"Images90_images__mdbx6"};